// 첫 구매 할인 금액 (부분 B안 고정으로 할인 없음 — 기본가 = 할인가)
export const FIRST_PURCHASE_DISCOUNT_AMOUNT = 0;

// 할인율 표시용 원가 (마케팅용, 실제 원가와 다름)
export const DISPLAY_ORIGINAL_PRICE = {
  BASIC: 40900, // 일반: 40,900원 (44% 할인 표시)
  PREMIUM: 79800, // 프리미엄: 79,800원 (50% 할인 표시)
};

export const BUY_REPORT_TICKET = {
  PREMIUM: {
    discountRate: "50%",
    originalPrice: 79800,
    unitPrice: 39900,
    orderType: "17",
    productCode: "PREMIUM",
  },
  BASIC: {
    discountRate: "44%",
    originalPrice: 40900,
    unitPrice: 22900,
    orderType: "12",
    productCode: "BASIC",
  },
  PETERPAN: {
    discountRate: "48%",
    originalPrice: 22900,
    unitPrice: 11900,
    orderType: "12",
    productCode: "PETERPAN",
  },
  UPGRADE: {
    discountRate: "0%",
    originalPrice: 19900,
    unitPrice: 19900,
    orderType: "16",
    productCode: "UPGRADE",
  },
};

// 기본가 = 할인가 (부분 B안 고정으로 할인 구분 없음)
export const BUY_REPORT_DISCOUNTED_PRICE = {
  BASIC: BUY_REPORT_TICKET.BASIC.unitPrice, // 22,900원
  PREMIUM: BUY_REPORT_TICKET.PREMIUM.unitPrice, // 39,900원
};

// 기본가 확인 헬퍼 (구 isFirstPurchasePrice — 이제 모든 유저 동일가)
export const isFirstPurchasePrice = price => {
  return (
    price === BUY_REPORT_TICKET.BASIC.unitPrice || price === BUY_REPORT_TICKET.PREMIUM.unitPrice
  );
};

// 일반 이용권 기본가 확인 (구 isBasicFirstPurchasePrice)
export const isBasicFirstPurchasePrice = price => {
  return price === BUY_REPORT_TICKET.BASIC.unitPrice;
};

// 프리미엄 가격 여부 확인
export const isPremiumPrice = price => {
  return price === BUY_REPORT_TICKET.PREMIUM.unitPrice;
};

// 매매리포트 설정. AB 테스트 종료 후 부분 B안(22,900/39,900)으로 고정.
export const getBuyReportConfig = () => {
  return {
    basicKey: "BASIC",
    premiumKey: "PREMIUM",
    basicTicket: BUY_REPORT_TICKET.BASIC,
    premiumTicket: BUY_REPORT_TICKET.PREMIUM,
    premiumDiscountedPrice: BUY_REPORT_DISCOUNTED_PRICE.PREMIUM,
    displayOriginalPrice: {
      basic: DISPLAY_ORIGINAL_PRICE.BASIC, // 40,900 (44%)
      basicFirstPurchase: DISPLAY_ORIGINAL_PRICE.BASIC, // 40,900 (44%)
      premiumFirstPurchase: DISPLAY_ORIGINAL_PRICE.PREMIUM, // 79,800 (50%)
      premiumNormal: DISPLAY_ORIGINAL_PRICE.PREMIUM, // 79,800 (50%)
    },
  };
};

// 리뷰 개수.
export const REVIEW_COUNT = {
  jeonse: 971,
  buy: 1092,
  subscribe: 1023,
};
